/**
 * Fila de categorías: centra el chip activo al cargar la página.
 */
class CategoryChips extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('[data-chips]');
    const active = list?.querySelector('.is-active');
    if (!list || !active) return;
    const listRect = list.getBoundingClientRect();
    const chipRect = active.getBoundingClientRect();
    list.scrollLeft += chipRect.left - listRect.left - (listRect.width - chipRect.width) / 2;
  }
}

if (!customElements.get('category-chips')) {
  customElements.define('category-chips', CategoryChips);
}
